import { AsyncPipe, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RxIntuitivePatientHeaderComponent } from '@modules/rx-intuitive-patient-header/containers/rx-intuitive-patient-header/rx-intuitive-patient-header.component';
import { RxIntuitivePatientDetailsComponent } from '@modules/rx-intuitive/components/rx-intuitive-patient-details/rx-intuitive-patient-details.component';
import { RxSelectProcedureComponent } from '@modules/rx-intuitive/components/rx-select-procedure/rx-select-procedure.component';
import { ProcedureTilesService } from '@modules/rx-intuitive/services/procedure-tiles.service';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { FLOW_RX_STEPS, FlowRxStep } from '@modules/rx-intuitive/models/flow-rx-step';
import { RxBannerComponent } from '@shared/components/rx-banner/rx-banner.component';
import { takeUntil } from 'rxjs/operators';
import { ProcedureSelectedPageComponent } from '../../components/procedure-selected-page/procedure-selected-page.component';
import { RxIntuitiveSummaryFooterComponent } from '@modules/rx-intuitive/components/rx-intuitive-summary-footer';
import { RxIntuitiveForDoctorFacade } from './rx-intuitive-for-doctor.facade';
import { MapperPipe } from '@shared/pipes/mapper.pipe';
import { RxIntuitiveStoresResetService } from '@shared/services/rx-intuitive-stores-reset.service';
import { RxIntuitiveTeethDiagramStore } from '@modules/rx-intuitive-teeth-diagram/state/rx-intuitive-teeth-diagram-store';
import { RxIntuitiveTeethDiagramQuery } from '@modules/rx-intuitive-teeth-diagram/state/rx-intuitive-teeth-diagram-query';

@Component({
	selector: 'rx-intuitive-for-doctor',
	templateUrl: './rx-intuitive-for-doctor.component.html',
	styleUrls: ['./rx-intuitive-for-doctor.component.scss'],
	imports: [
		NgIf,
		AsyncPipe,
		RxSelectProcedureComponent,
		RxIntuitivePatientHeaderComponent,
		ProcedureSelectedPageComponent,
		RxIntuitivePatientDetailsComponent,
		RxBannerComponent,
		RxIntuitiveSummaryFooterComponent,
		TranslateModule,
		NgSwitch,
		NgSwitchCase,
		MapperPipe
	],
	providers: [ProcedureTilesService, RxIntuitiveForDoctorFacade, RxIntuitiveStoresResetService, RxIntuitiveTeethDiagramStore, RxIntuitiveTeethDiagramQuery],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class RxIntuitiveForDoctorComponent extends BaseDestroyableComponent implements OnInit, AfterViewInit {
	readonly isSummaryMode$ = this.facade.isSummaryMode$;
	readonly isReadOnlyBannerVisible$ = this.facade.isReadOnlyBannerVisible$;

	@Output() sendClicked = new EventEmitter<void>();

	readonly flowRxSteps = FLOW_RX_STEPS;

	step$ = this.facade.flowRxStep$;

	constructor(private readonly facade: RxIntuitiveForDoctorFacade) {
		super();
	}

	ngOnInit(): void {
		this.facade.resetFlowRxStep();
	}

	ngAfterViewInit(): void {
		this.facade
			.getInitialStep()
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(step => this.facade.updateFlowRxStep(step));
	}

	goToStep(flowRxStep: FlowRxStep): void {
		this.facade.updateFlowRxStep(flowRxStep);
	}

	shouldShowPatientHeader(flowRxStep: FlowRxStep | undefined): boolean {
		return flowRxStep === FLOW_RX_STEPS.ProcedureSelection || flowRxStep === FLOW_RX_STEPS.RxForm;
	}
}
